
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class StajBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "StajBasvuruSave";
    super(baseUrl);
  }


  saveStajBasvuruSave(request: StajBasvuruSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new StajBasvuruAPI();

class StajBasvuruSaveRequest {
    basvuruTuruId: number;
    tcKimlikNo: number;
    dogumTarihi: Date;
    ad: string;
    soyad: string;
    cepTelefonu: string;
    acikAdres: string;
    okulId: number;
    fakulteId?: number;
    ogrenimYili?: string;
    sgkBaslangicTarihi: Date;
    stajBaslamaTarihi: Date;
    stajBitisTarihi: Date;
    ibanNo?: string;
    pazartesi?: number;
    sali?: number;
    carsamba?: number;
    persembe?: number;
    cuma?: number;
    captchaToken?: string;

    constructor(basvuruTuruId: number, tcKimlikNo: number, dogumTarihi: Date, ad: string, soyad: string, cepTelefonu: string, acikAdres: string, okulId: number,sgkBaslamaTarihi:Date, stajBaslamaTarihi: Date, stajBitisTarihi: Date, fakulteId?: number, ogrenimYili?: string, ibanNo?: string, pazartesi?: number, sali?: number, carsamba?: number, persembe?: number, cuma?: number,captchaToken?: string) {
        this.basvuruTuruId = basvuruTuruId;
        this.tcKimlikNo = tcKimlikNo;
        this.dogumTarihi = dogumTarihi;
        this.ad = ad;
        this.soyad = soyad;
        this.sgkBaslangicTarihi = sgkBaslamaTarihi;
        this.cepTelefonu = cepTelefonu;
        this.acikAdres = acikAdres;
        this.okulId = okulId;
        this.stajBaslamaTarihi = stajBaslamaTarihi;
        this.stajBitisTarihi = stajBitisTarihi;
        this.fakulteId = fakulteId;
        this.ogrenimYili = ogrenimYili;
        this.ibanNo = ibanNo;
        this.pazartesi = pazartesi;
        this.sali = sali;
        this.carsamba = carsamba;
        this.persembe = persembe;
        this.cuma = cuma;
        this.captchaToken = captchaToken;
    }
}
export { StajBasvuruSaveRequest };